import React from 'react';
import { SectionContentSubTitleTypes } from './SectionContentSubTitleTypes';

export const SectionContentSubTitle = ({
  children,
  RenderAs = 'h6',
}: SectionContentSubTitleTypes.ISectionSubTitle) => {
  return <RenderAs className="sectionContentSubTitle">{children}</RenderAs>;
};
